import Swiper, {Navigation, Pagination} from 'swiper';
import helpers from '../helpers';
Swiper.use([Navigation, Pagination]);

export class Content {
	constructor() {
		this.popup = document.querySelector('.popup-content');
		this.popupScrollWrapper = document.querySelector('.popup-content__scroll-wrapper');
		this.btnClose = this.popup.querySelector('.popup-content__close');
		this.btnClose.addEventListener('click', this.close.bind(this));
		this.time = 400;
		this.windowHtml = document.querySelector('HTML');
		this.isMobile = window.innerWidth < 850;
		this.checkOpen = false;
		this.currentData = null;
		document.querySelector('.header__back').addEventListener('click', this.close.bind(this));
	}

	get(id, data) {
		const oldContent = document.querySelector('.popup-content__container');
		const newContentContainer = document.createElement('div');
		const adressLink = `maps.google.com/maps?q=${encodeURIComponent(data[id].address)}`;
		const activElem = document.getElementById(id);

		this.currentData = data[id];

		this.removeActiveClass();

		// eslint-disable-next-line
		activElem && activElem.classList.add("active");
		oldContent.remove();
		newContentContainer.classList.add('popup-content__container');

		newContentContainer.innerHTML = `
            <div class="popup-content__descripton">${data[id].typeDescription}</div>
            <div class="popup-content__title">${data[id].name}</div>
            <div class="popup-content__row">
                <a href="http://${adressLink}" target="_blank" class="popup-content__location">
                    <svg>
                        <use xlink:href="./images/sprites.svg#icon-pos"></use>
                    </svg><span>${data[id].address}</span>
                </a>
                <a href="${data[id].link}" class="popup-content__link" target="_blank">
                    <svg>
                        <use xlink:href="./images/sprites.svg#icon-link"></use>
                    </svg><span>Сайт музея</span>
                </a>
            </div>
            <div class="popup-content__slider">
                <div class="swiper">
                    <div class="swiper-wrapper">
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <div class="popup-content__text">
				<p>${data[id].text}</p>
				<h4 class="popup-content__event-title">${data[id].eventTitle || 'Мероприятия:'}</h4>
				<ul class="popup-content__event-list"></ul>
				<h4 class="popup-content__tel-title">Контактная информация:</h4>
				<ul class="popup-content__tel-list"></ul>
				<p>${data[id].caption || ''}</p>
			</div>
        `;

		this.popupScrollWrapper.prepend(newContentContainer);
		document.querySelector('.header__search-wrapper').classList.add('relative');

		// для пеерхода http c https
		const link = document.querySelector('.popup-content__link');
		link.href = `http://${data[id].link}`;

		this.mobileStart();
		this.getSlide(data, id);
		this.getMuseumEvent(data, id);
		this.getMuseumTel(data, id);
		this.open();
	}

	open() {
		this.checkOpen = true;
		$('html').scrollTop(0);

		if (this.isMobile) {
			const search = document.querySelector('.header__search');
			const searchResultWrapper = document.querySelector('.header__search-wrapper');

			if (!search.classList.contains('.header__search_content-active')) {
				setTimeout(() => {
					search.classList.add('header__search_content-active');
					searchResultWrapper.classList.add('header__search-wrapper_top');
				}, 1000);
			}

			setTimeout(() => {
				this.popup.style.opacity = 1;
				this.popup.style.transform = 'translateX(0)';
				setTimeout(() => {
					document.querySelector('.site').classList.add('popup-open');
				}, 400);
			}, this.time);

			document.querySelector('.header__longread').classList.add('hide');
			document.querySelector('.header__back').classList.remove('hide');
		} else {
			this.windowHtml.style.overflow = 'hidden';
			this.popup.style.display = 'block';

			helpers.scrollTo($('body'));
			$(this.popupScrollWrapper).scrollTop(0);

			this.setPosition();

			setTimeout(() => {
				this.popup.style.opacity = 1;
				this.popup.style.transform = 'translateY(0)';
			}, this.time);
		}
	}

	close() {
		this.checkOpen = false;

		if (this.isMobile) {
			const search = document.querySelector('.header__search');
			const searchResultWrapper = document.querySelector('.header__search-wrapper');

			if (search.classList.contains('header__search_content-active')) {
				search.classList.remove('header__search_content-active');
				searchResultWrapper.classList.remove('header__search-wrapper_top');
			}

			setTimeout(() => {
				this.popup.style.opacity = 0;
				this.popup.style.transform = 'translateX(100%)';
				document.querySelector('.site').classList.remove('popup-open');
			}, this.time);

			this.removeActiveClass();
			document.querySelector('.header__longread').classList.remove('hide');
			document.querySelector('.header__back').classList.add('hide');
		} else {
			this.windowHtml.style.overflow = 'auto';
			this.popup.style.opacity = 0;
			this.popup.style.transform = 'translateY(-200px)';

			setTimeout(() => {
				this.popup.style.display = 'none';
			}, this.time);

			this.removeActiveClass();
		}
	}

	setPosition() {
		const header = document.querySelector('.header__wrapper');
		const posX = header.getBoundingClientRect().x + header.offsetWidth - 2;

		if (this.checkOpen) {
			this.popup.style.display = 'block';
		}

		this.popup.style.left = `${posX}px`;
		this.popup.style.width = `${window.innerWidth - posX}px`;

		if (this.isMobile) {
			this.popup.style.left = 0;
			this.popup.style.width = '100%';
		}
	}

	removeActiveClass() {
		document.querySelectorAll('.header__search-result-item').forEach((el) => {
			if (el.classList.contains('active')) {
				el.classList.remove('active');
			}
		});
	}

	getSlide(data, id) {
		if (data[id].img.length === 0) {
			const slider = document.querySelector('.popup-content__slider');
			slider.remove();
		} else {
			const slider = document.querySelector('.swiper-wrapper');

			data[id].img.forEach((el, index) => {
				const slide = document.createElement('div');
				slide.classList.add('swiper-slide');
				slide.innerHTML = `<img src="images/museums/${id}/0${index + 1}.jpg" alt="photo">`;
				slider.appendChild(slide);
			});

			this.sliderInit();
		}
	}

	getMuseumEvent(data, id) {
		const eventList = document.querySelector('.popup-content__event-list');

		if (data[id].event.length === 0) {
			const eventTitle = document.querySelector('.popup-content__event-title');
			eventTitle.remove();
			eventList.remove();
		}

		data[id].event.forEach((el, index) => {
			const newEvent = document.createElement('li');
			newEvent.classList.add('popup-content__event');

			if (el === 'Планируемые мероприятия:') {
				newEvent.classList.add('no-dash');
			}

			newEvent.innerHTML = el;
			eventList.appendChild(newEvent);
		});
	}

	getMuseumTel(data, id) {
		const eventList = document.querySelector('.popup-content__tel-list');

		data[id].tel.forEach((el, index) => {
			const newTel = document.createElement('li');
			// const num = parseInt(el.replace(/\D+/g,""));  для ссылки с номером

			newTel.classList.add('popup-content__tel');
			newTel.innerText = el;

			eventList.appendChild(newTel);
		});
	}

	sliderInit() {
		const swiper = new Swiper('.swiper', {
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			observer: true,
			observeParents: true,
		});

		swiper.on('slideChange', () => {
			const name = document.querySelector('.popup-content__title').textContent;
			ga('send', 'event', 'map', 'detail popup museum slider', `${this.currentData.location} - ${name}`);
		});
	}

	mobileStart() {
		if (this.isMobile) {
			const elLink = document.querySelector('.popup-content__link');
			const popupTitle = document.querySelector('.popup-content__title');

			popupTitle.appendChild(elLink);
		}
	}

	resize() {
		this.isMobile = window.innerWidth < 850;

		this.setPosition();
	}
}
